"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisciplineStencil = exports.disciplineStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.disciplineStencilDefinition = {
    view: {
        label: 'Discipline',
        category: 'tag',
        group: 'Taxonomy',
        titleItems: ['title'],
        imageItems: [],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'preferred-label',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'alternative-labels',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['broader-discipline', 'related-content'],
            },
        ],
    },
    content: {
        'alternative-labels': properties_1.alternativeLabelsPropertyDefinition,
        'broader-discipline': properties_1.broaderDisciplinePropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'preferred-label': properties_1.preferredLabelPropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        title: properties_1.titlePropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
    },
    localizations: ['en'],
    roles: ['taxonomy-manager'],
    spaces: [
        'erc',
        'pro-cycling',
        'speedweek',
        'wrc',
    ],
    name: 'discipline',
};
const isDisciplineStencil = (stencil) => {
    return stencil.name === exports.disciplineStencilDefinition.name;
};
exports.isDisciplineStencil = isDisciplineStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzY2lwbGluZS5zdGVuY2lsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0ZW5jaWxzL2Rpc2NpcGxpbmUuc3RlbmNpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSw4Q0FZc0I7QUFFVCxRQUFBLDJCQUEyQixHQUFHO0lBQ3pDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxZQUFZO1FBQ25CLFFBQVEsRUFBRSxLQUFLO1FBQ2YsS0FBSyxFQUFFLFVBQVU7UUFDakIsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFVBQVUsRUFBRSxFQUFFO1FBQ2QsWUFBWSxFQUFFO1lBQ1o7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osS0FBSyxFQUFFLENBQUMsT0FBTyxDQUFDO2FBQ2pCO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osUUFBUSxFQUFFO29CQUNSO3dCQUNFLElBQUksRUFBRSxTQUFTO3dCQUNmLEtBQUssRUFBRTs0QkFDTCxpQkFBaUI7NEJBQ2pCLFdBQVc7NEJBQ1gsY0FBYzs0QkFDZCxnQkFBZ0I7NEJBQ2hCLFdBQVc7NEJBQ1gsb0JBQW9CO3lCQUNyQjtxQkFDRjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsVUFBVTt3QkFDaEIsS0FBSyxFQUFFLENBQUMsWUFBWSxDQUFDO3FCQUN0QjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsbUJBQW1CO3dCQUN6QixLQUFLLEVBQUUsQ0FBQyxzQkFBc0IsQ0FBQztxQkFDaEM7aUJBQ0Y7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxTQUFTO2dCQUNmLEtBQUssRUFBRSxDQUFDLG9CQUFvQixFQUFFLGlCQUFpQixDQUFDO2FBQ2pEO1NBQ0Y7S0FDRjtJQUNELE9BQU8sRUFBRTtRQUNQLG9CQUFvQixFQUFFLGdEQUFtQztRQUN6RCxvQkFBb0IsRUFBRSxnREFBbUM7UUFDekQsZ0JBQWdCLEVBQUUsNENBQStCO1FBQ2pELGlCQUFpQixFQUFFLDZDQUFnQztRQUNuRCxzQkFBc0IsRUFBRSxrREFBcUM7UUFDN0QsaUJBQWlCLEVBQUUsNkNBQWdDO1FBQ25ELFdBQVcsRUFBRSx1Q0FBMEI7UUFDdkMsY0FBYyxFQUFFLDBDQUE2QjtRQUM3QyxVQUFVLEVBQUU7WUFDVixHQUFHLHlDQUE0QjtZQUMvQixPQUFPLEVBQUUsSUFBSTtTQUNkO1FBQ0QsS0FBSyxFQUFFLG9DQUF1QjtRQUM5QixXQUFXLEVBQUUsdUNBQTBCO0tBQ3hDO0lBQ0QsYUFBYSxFQUFFLENBQUMsSUFBSSxDQUFDO0lBQ3JCLEtBQUssRUFBRSxDQUFDLGtCQUFrQixDQUFDO0lBQzNCLE1BQU0sRUFBRTtRQUNOLEtBQUs7UUFDTCxhQUFhO1FBQ2IsV0FBVztRQUNYLEtBQUs7S0FDTjtJQUNELElBQUksRUFBRSxZQUFZO0NBQ1ksQ0FBQTtBQUl6QixNQUFNLG1CQUFtQixHQUFHLENBQUMsT0FBb0IsRUFBZ0MsRUFBRTtJQUN4RixPQUFPLE9BQU8sQ0FBQyxJQUFJLEtBQUssbUNBQTJCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsbUJBQW1CLHVCQUUvQiJ9